export const LABELS = {
  repositoryOwner: 'Repository owner',
  metadataHeader: 'Metadata',
  metadataLabel: 'Details',
  timeline: {
    header: 'Activity',
    added: 'added',
    removed: 'removed',
    removedTheirAssignment: 'removed their assignment',
    unassigned: 'unassigned',
    locked: 'locked',
    limitedToCollaborators: 'and limited conversation to collaborators',
    unlockedConversation: 'unlocked this conversation',
    pinned: 'pinned this issue',
    unpinned: 'unpinned this issue',
    closedThis: 'closed this',
    subscribed: 'subscribed',
    unsubscribed: 'unsubscribed',
    mentioned: 'mentioned this',
    as: 'as',
    in: 'in',
    of: 'of',
    to: 'to',
    and: 'and',
    reopenedThis: 'reopened this',
    selfAssignedThis: 'self-assigned this',
    assigned: 'assigned',
    temporarily: 'temporarily',
    blocked: 'blocked',
    deletedACommentFrom: 'deleted a comment from',
    addedToMilestone: 'added this to the',
    removedFromMilestone: 'removed this from the',
    milestone: 'milestone',
    milestoneDeleted: 'This milestone has been deleted',
    renamedTitle: 'changed the title',
    mentionedThisIn: 'mentioned this',
    linkedAClosingPR: 'linked a pull request that will close this issue',
    addedCommitsThatReferences: (numCommits: number) =>
      `added ${numCommits === 1 ? 'a' : numCommits} commit${numCommits === 1 ? '' : 's'} that reference${
        numCommits === 1 ? 's' : ''
      } this issue`,
    transferredThis: 'transferred this issue from',
    issueFromNote: 'created this issue from a note in',
    removedLinkedPR: 'removed a link to a pull request',
    markedAsDuplicate: 'marked this as a duplicate of',
    unmarkedAsDuplicate: 'unmarked this as a duplicate of',
    convertedToDiscussion: 'converted this issue into a discussion',
    convertedFromDraftIssue: 'converted this from a draft issue',
    addedThisTo: 'added this to',
    removedThisFrom: 'removed this from',
    movedThisFrom: 'moved this from',
    movedThisTo: 'moved this to',
    loadMore: (numberOfTimelineItems: number) => `Load ${numberOfTimelineItems} more`,
    loadAll: 'Load all',
    loadNewer: 'Load newer activity',
    loadOlder: 'Load older activity',
    announcements: {
      loadRemaining: 'Loading remaining timeline items',
      loadOlder: 'Loading older timeline items',
      loadNewer: 'Loading newer timeline items',
    },
    modifiedMilestones: 'modified the milestones:',
    modifiedMilestone: 'modified the milestone:',
    subIssueAdded: {
      single: 'added a sub-issue',
      multiple: 'added sub-issues',
    },
    subIssueRemoved: {
      single: 'removed a sub-issue',
      multiple: 'removed sub-issues',
    },
    parentIssueAdded: {
      single: 'added a parent issue',
      multiple: 'added parent issues',
    },
    parentIssueRemoved: {
      single: 'removed a parent issue',
      multiple: 'removed parent issues',
    },
    blockedByAdded: {
      single: 'marked this as blocked',
      multiple: (count: number) => `marked this as blocked by ${count} issues`,
    },
    blockedByRemoved: {
      single: 'unmarked this as blocked',
      multiple: (count: number) => `unmarked this as blocked by ${count} issues`,
    },
    blockingAdded: {
      single: 'marked this as blocking',
      multiple: (count: number) => `marked this as blocking ${count} issues`,
    },
    blockingRemoved: {
      single: 'unmarked this as blocking',
      multiple: (count: number) => `unmarked this as blocking ${count} issues`,
    },
    relatesToAdded: {
      single: 'added a related issue',
      multiple: (count: number) => `added ${count} related issues`,
    },
    relatesToRemoved: {
      single: 'removed a related issue',
      multiple: (count: number) => `removed ${count} related issues`,
    },
    issueTypeAdded: {
      leading: 'added the',
      trailing: 'issue type',
    },
    issueTypeRemoved: {
      leading: 'removed the',
      trailing: 'issue type',
    },
    issueTypeChanged: {
      leading: 'changed the issue type from',
      trailing: 'to',
    },
    issueFieldAdded: {
      leading: 'set',
      trailing: 'to',
    },
    issueFieldChanged: {
      leading: 'changed',
      trailing: 'to',
    },
    issueFieldRemoved: {
      leading: 'cleared',
    },
    issueFieldRollup: {
      updated: 'updated',
      removed: 'removed',
      andAlso: 'and also',
    },
    issueCommentPinned: {
      leading: 'pinned',
      comment: 'comment',
    },
    issueCommentUnpinned: {
      leading: 'unpinned',
      comment: 'comment',
    },
  },
  crossReferencedEventLockTooltip: (repoNameWithOwner: string) =>
    `Only people who can see ${repoNameWithOwner} will see this reference.`,
  crossReferencedEvent: {
    sectionLabel: 'Issues mentioned',
    privateRepositoryButtonLabel: (repoNameWithOwner: string) => `Private repository: ${repoNameWithOwner}`,
    privateEventDescription: 'This event is from a private repository and is only visible to repository members',
  },
  commitWillCloseMessage: (subjectType: string, abbreviatedOid: string, defaultBranch: string) =>
    `This ${
      subjectType === 'Issue' ? 'issue' : 'pull request'
    } will close once commit ${abbreviatedOid} is merged into the '${defaultBranch}' branch.`,
  undoMarkIssueAsDuplicate: (cannonicalIssueNumber: number) =>
    `Undo marking issue as duplicate of issue #${cannonicalIssueNumber}`,
}
